const initialState = {
  vehicles: []
};

export function fetchVehicles(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.CUSTOMER_VEHICLE.SUCCESS':
      return {
        ...state,
        vehicles:  action.vehicles.body,
      };
    default:
      return state
  }
}
